/**
 * There are many ways to validate email address but it is a real rabbit hole.
 *
 * If you want a strictly valid email address, this answer is worth a look:
 *
 *   https://stackoverflow.com/a/201378/3509004
 *
 * But that will allow through many weird and wonderful things which if in fact typed by one of our
 * hapless users they almost certainly did not intend.  To catch those validation problems maybe you
 * want something like:
 *
 *   "^[a-zA-Z0-9._%+-]{1,64}@(?:[A-Za-z0-9-]{1,63}\.){1,8}[A-Za-z]{2,63}$"
 *
 * from http://www.regular-expressions.info/email.html
 *
 * But rather than do any of that, we go as simple as possible for now, as follows.
 * This function matches a database function isValidEmailAddress which is not as strict
 * as this one.
 */

function isFirstOrLastChar(text: string, char: string) {
  if (text.length === 0) {
    return false
  }
  return text.charAt(0) === char || text.slice(-1) === char
}

export function isValidEmailAddress(email: string): boolean {
  if (email.length < 3) {
    return false
  }
  if (isFirstOrLastChar(email, ".") || isFirstOrLastChar(email, "@")) {
    return false
  }
  return email.indexOf("@") !== -1
}



// WEBPACK FOOTER //
// ./src/email.ts